import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LoadingSpinner from './LoadingSpinner';

const LoadingOverlay = ({ loading, size = 'lg', id, className }) => (
  <div className="overlay-outer">
    {loading && (
      <div className={cx('overlay', className)}>
        <div className="overlay-inner text-blue-active">
          <LoadingSpinner size={size} id={id} />
        </div>
      </div>
    )}
  </div>
);

LoadingOverlay.propTypes = {
  loading: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  id: PropTypes.string,
  className: PropTypes.string,
};

export default LoadingOverlay;
